import { render, staticRenderFns } from "./MyStudents.vue?vue&type=template&id=c11ebe1c&"
import script from "./MyStudents.vue?vue&type=script&lang=js&"
export * from "./MyStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports